module.exports = __webpack_public_path__ + "static/Retrieve-a7ea558d32abdd01e195d359fecba3a8.png";